import CorporateFareRoundedIcon from '@mui/icons-material/CorporateFareRounded';
import {
  Create,
  CreateButton,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  ExportButton,
  Filter,
  FormTab,
  List,
  NullableBooleanInput,
  NumberInput,
  Resource,
  SaveButton,
  SearchInput,
  ShowButton,
  ShowGuesser,
  SimpleForm,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
} from 'react-admin';

import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import UserReferenceField from 'shared-fields/UserReferenceField';
import UserReferenceInput from 'shared-fields/UserReferenceInput';
import { rolesMatch } from 'utils/user';
import { CopyField } from 'shared-fields/CopyField';

function OrganizationFilter(props) {
  return (
    <Filter {...props}>
      <SearchInput
        key="searchQuery"
        source="searchQuery"
        alwaysOn
        sx={{
          '& .MuiFilledInput-root': {
            minWidth: 110,
            width: 150,
          },
        }}
      />
    </Filter>
  );
}

export function OrganizationListContent() {
  const hasRole = useHasRole();
  return (
    <Datagrid bulkActionButtons={false}>
      <CopyField source="id" label="ID" />
      <CopyField source="title" />
      <UserReferenceField source="ownerId" />
      <DateField source="createdAt" showTime locales="fa-IR" />
      <DateField source="updatedAt" showTime locales="fa-IR" />
      {
        hasRole(Role.SUPER_ADMIN) && (
          <EditButton />
        )
      }
      <ShowButton />
    </Datagrid>
  );
}
export function OrganizationList() {
  const hasRole = useHasRole();
  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
      filters={<OrganizationFilter />}
      perPage={25}
      actions={(
        <TopToolbar>
          {hasRole(Role.SUPER_ADMIN) && <ExportButton />}
          {hasRole(Role.SUPER_ADMIN) && <CreateButton />}
        </TopToolbar>
      )}
    >
      <OrganizationListContent />
    </List>
  );
}

export function OrganizationEdit(props) {
  return (
    <Edit {...props}>
      <TabbedForm toolbar={(
        <Toolbar>
          <SaveButton />
        </Toolbar>
      )}
      >
        <FormTab label="General">
          <TextInput source="id" disabled />
          <TextInput source="title" />
          <UserReferenceInput source="ownerId" />
          <TextInput source="telegramGroupChatId" />
          <TextInput source="slug" />
          <NumberInput source="minimumFee" />
          <DateField source="createdAt" showTime locales="fa-IR" disabled />
          <DateField source="updatedAt" showTime locales="fa-IR" disabled />
        </FormTab>
        <FormTab label="Parent" path="parent">
          <UserReferenceInput source="parentIncomeSharing.userId" label="Parent user" />
          <NumberInput source="parentIncomeSharing.percentage" label="Percentage" helperText={false} />
          <NumberInput source="parentIncomeSharing.minimumFee" label="Minimum fee" helperText={false} />
          <TextInput source="parentIncomeSharing.description" label="Description" />
        </FormTab>
        <FormTab label="Config" path="config">
          <NullableBooleanInput
            source="config.disableSMS"
            label="Disable SMS"
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
}

export function OrganizationCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" />
        <TextInput source="description" multiline />
      </SimpleForm>
    </Create>
  );
}

export const renderOrganizationResource = (roles) => (
  <Resource
    name="organizations"
    icon={CorporateFareRoundedIcon}
    show={ShowGuesser}
    list={OrganizationList}
    edit={rolesMatch({ roles, role: Role.INCOME_EDIT }) && OrganizationEdit}
    create={rolesMatch({ roles, role: Role.INCOME_CREATE }) && OrganizationCreate}
  />
);
